import { Box, Typography, TextField } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { styles } from './styles';

import type { EmailFormProps } from './types';

export const EmailForm: FC<EmailFormProps> = ({ value, onChange }) => {
    const { t } = useTranslation();

    return (
        <Box css={styles.wrapper}>
            <Box css={styles.title}>
                <Typography variant="h4">{t('agreements_email_form_title')}</Typography>
                <Typography variant="h4" css={styles.astericks}>
                    *
                </Typography>
            </Box>
            <TextField
                id="standard-basic"
                variant="standard"
                fullWidth
                value={value}
                onChange={onChange}
                placeholder={t('agreements_email_form_placeholder')}
            />
        </Box>
    );
};
